import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { UserEntity } from './user.entity';

@Index('idx_list_usage_stats_unique', ['fkUserId', 'listKey', 'listId'], {
	unique: true,
})
@Index('idx_list_usage_stats_user', ['fkUserId'])
@Index('idx_list_usage_stats_list_key', ['listKey'])
@Entity('list_usage_stats')
export class ListUsageStatsEntity extends BaseEntity {
	@Column('int', { name: '_fk_user__id', unsigned: true })
	public fkUserId!: number;

	@Column('varchar', { name: '_list_key', length: 100 })
	public listKey!: string;

	@Column('varchar', { name: '_list_id', length: 100 })
	public listId!: string;

	@Column('datetime', { name: '_last_used_at', nullable: true })
	public lastUsedAt!: Date | null;

	@Column('int', { name: '_use_count', unsigned: true, default: 0 })
	public useCount!: number;

	@ManyToOne(() => UserEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity | null;
}
